import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[svgButtonListner]'
})
export class HighlightDirective {
  @Output() onHighlight: EventEmitter<string> = new EventEmitter<any>();

  constructor(private el: ElementRef) { }

  @HostListener('mouseenter') onMouseEnter() {
    this.onHighlight.emit("hover");
  }
  
  @HostListener('mouseleave') onMouseLeave() {
    this.onHighlight.emit(null);
  }

  @HostListener('mousedown') onMouseDown() {
    this.onHighlight.emit("clicked");
  }

  @HostListener('mouseup') onMouseUp() {
    this.onHighlight.emit("hover");
  }

}
